<template>
  <b-navbar type="light" toggleable="md">
    <!-- Header with logos -->
    <div class="navbar-header navbar-dark d-none d-md-flex align-items-md-center">
      <div class="navbar-brand navbar-brand-md">
				<a href="dashboard.php" class="d-inline-block">
					<img src="/img/logo-text.png" alt="ONE-DA Logo" style="height:32px;">
				</a>
			</div>
			
			<div class="navbar-brand navbar-brand-xs">
				<a href="dashboard.php" class="d-inline-block">
					<img src="/img/logo-icon.png" style="height:32px;" alt="ONE-DA Logo">
				</a>
			</div>
    </div>
    <!-- /header with logos -->

    <!-- Mobile controls -->
    <div class="d-flex flex-1 d-md-none">
			<div class="navbar-brand mr-auto">
				<a href="dashboard.php" class="d-inline-block">
					<img src="/img/logo_astra-dark.png" alt="">
				</a>
			</div>	

			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
				<i class="icon-tree5"></i>
			</button>

			<button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
				<i class="icon-paragraph-justify3"></i>
			</button>
    </div>
    <!-- /mobile controls -->

    <!-- Navbar content -->
    <b-collapse is-nav id="navbar-mobile">
      <b-navbar-nav class="align-items-center">
        <b-nav-item
          link-classes="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block"
          @click="toggleSidebarDesktop"
        >
          <i class="icon-paragraph-left3"></i>
        </b-nav-item>
      </b-navbar-nav>
      <b-badge
        pill
        class="ml-md-3 mr-md-auto bg-success"
      >
        online
      </b-badge>
      <b-navbar-nav class="align-items-center">
        <b-nav-item-dropdown right @show="openNotif" toggle-class="navbar-nav-link d-flex align-items-center" menu-class="wmin-md-350 py-0" no-caret>
          <template #button-content>
            <i class="icon-bell3"></i>
            <span class="d-md-none ml-2">Messages</span>
            <span  v-if="(notificationList.data||[]).findIndex(x=>x.an_status == 'D') !== -1" class="badge badge-mark border-pink-400 ml-auto ml-md-0"></span>
          </template>
          <div class="dropdown-content-header">
            <span class="font-weight-semibold">Messages</span>
          </div>
          <div class="dropdown-content-body dropdown-scrollable">
            <ul class="media-list" v-if="(notificationList.data||[]).length">
              <li class="media" v-for="(v,k) in (notificationList.data||[])" :key="k">
                <template v-if="Object.keys(v.an_data||{}).length">
                  <div class="mr-3 position-relative">
                    <img :src="uploader(v.an_data.avatar)" width="36" height="36" class="rounded-circle" alt="">
                  </div>
                  <div class="media-body">
                    <div class="media-title">
                      <a href="#">
                        <span class="font-weight-semibold">{{v.an_data.level}}</span>
                        <span class="text-muted float-right font-size-sm">{{momentDate(v.an_created_date)}}</span>
                      </a>
                    </div>
                    <span class="text-muted">{{v.an_message}}</span>
                    <span class="text-muted">
                        <span :class="v.an_status == 'D'?'text-muted float-right font-size-sm mt-3':'text-info float-right font-size-sm mt-3'">{{v.an_status == 'D' ? 'Belum Dibaca' : 'Sudah Dibaca'}}</span>
                    </span>
                  </div>
                </template>
							</li>
            </ul>
            <span v-else>No Messages Found</span>
          </div>
          <div class="dropdown-content-footer bg-light">
            <router-link :to="{name: 'Notification'}" v-if="(notificationList.data||[]).length"
              class="text-grey mr-auto" >All messages</router-link>
          </div>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right toggle-class="navbar-nav-link d-flex align-items-center">
          <template #button-content>
            <span class="w_plus"><i class="icon-plus2"></i></span>
          </template>
          <b-dropdown-item :to="{name: 'BoDebiturIndividual'}">
            <i class="icon-user-plus"></i> Tambah Debitur Individu
          </b-dropdown-item>
          <b-dropdown-item :to="{name: 'BoDebiturPerusahaan'}">
            <i class="icon-user-plus"></i> Tambah Debitur Perusahaan
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item :to="{name: 'BoLoan'}">
            <i class="icon-cash2"></i> Tambah Fasilitas
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right toggle-class="navbar-nav-link d-flex align-items-center">
          <template #button-content>
            <b-img
              :src="uploader(user.avatar)"
              class="mr-2"
              rounded="circle"
              height="34"
              alt=""
            />
            <span>{{ user.fullName }}</span>
          </template>
          <b-dropdown-item :to="{name: 'BoAccountSetting'}">
            <i class="icon-cog5"></i> Account settings
          </b-dropdown-item>
          <b-dropdown-item @click="doLogout">
            <i class="icon-switch2"></i> Logout
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  
</template>

<script>
import GlobalVue from '@/libs/Global.vue'
import Gen from '@/libs/Gen.js'
const moment = require('moment')

export default {
  extends: GlobalVue,
  data() {
    return {
      notificationList: [],
    }
  },
  methods: {
    momentDate(dates){
      let formatted = moment(dates).format("YYYYMMDDHHmm")
      let newDates = moment(formatted, "YYYYMMDDHHmm").fromNow()
      return newDates
    },
    toggleSidebarDesktop() {
      document.querySelector('body').classList.toggle('sidebar-xs')
    },
    logout() {
      this.$store.commit('unsetAuth')
      this.$router.push({ name: 'BoAuth' })
    },

    getNotification(){
      console.log(this.user.id)
      Gen.apiRest(
        "/get/"+"Notification",
        {
          params: {
            id : parseInt(this.user.id),
            levelId : parseInt(this.user.levelId),
          }
        }
      ).then(res=>{
        this.notificationList = res.data.data
      })
    },

    openNotif(){
      let id = []
      for (let i = 0; i < this.notificationList.data.length; i++) {
        if(this.notificationList.data[i].an_status == "D"){
          id.push(this.notificationList.data[i].an_id)
        }
      }
      if(id.length){
        Gen.apiRest('/do/'+'Notification', {data: {type:'updateNotif', id: id}}, 'POST').then(()=>{
          this.getNotification()
        })
      }
    }
  },
  mounted() {
    this.getNotification()
  },
  watch:{
    $route(){
      this.getNotification()
    }
  } 
}
</script>